import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { CallLogDetailService } from './call-log-detail.service';
import * as $ from 'jquery';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators, MaxLengthValidator } from '@angular/forms';
import { Router } from '@angular/router';
import { CodificadorJWT } from 'src/util/codificador/CodificadorJWT';
import { PrivacyService } from '../privacy/privacy.service';
declare var $: any;
@Component({
  selector: 'app-call-log-detail',
  templateUrl: './call-log-detail.component.html',
  styleUrls: ['./call-log-detail.component.scss'],
})

export class CallLogDetailComponent implements OnInit {
  callLogForm: FormGroup;
  modalTitle = "";
  modalContent = "";
  valueAes = ""
  isShowModal = false;
  isModalReload = false;
  isShowTermsModal = false;
  isTermsChecked = false;
  isAuthChecked = false;
  numericPattern = "";
  requestedLine = "";
  isBtnDisabled = true;
  currentDate = new Date();
  maxDateToInitDate = new Date();
  optionsFormatDate = { year: 'numeric', month: '2-digit', day: '2-digit' };

  //listado de lineas
  listLines = [];

  //valores de entrante o saliente
  outputValue = 0;
  inputValue = 0;
  inOutSelected = 1;
  difDaysValidation = 0;

  //constructor del componente
  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private callLogDetailService: CallLogDetailService, private privacyService: PrivacyService) { }

  /**
  * Description: Método que inicializa y carga las variables del formulario
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  ngOnInit() {
    this.getSemillaAesParam()
    
    //se inicializan los inputs para las validaciones con sus respectivas expresiones regulares
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.callLogForm = this.formbuilder.group({
      inputDays: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputCost: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputBalance: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputLines: ['', [Validators.required]],
      inputInitDate: ['', [Validators.required]],
      inputEndDate: ['', [Validators.required]],
    });

    //obtiene las lineas de sesion
    let userData = JSON.parse(localStorage.getItem("userData"));
    for (var k in userData.associatedCellPhones) {
      this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
    }

    //llamado al metodo que llena los tooltip
    this.setTooltips();
    this.getInOutputValue();
  }

  /**
  * Description: Método que setea la información de los tooltips de la página
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  setTooltips() {
    $('#tooltipDateRange').popover({
      html: true,
      content: this.LANG.getLangText('CALL_LOG_TOOLTIP_RANGE')
    });
    $('#tooltipCost').popover({
      html: true,
      content: this.LANG.getLangText('CALL_LOG_TOOLTIP_COST')
    });
  }

  /**
  * Description: Método que obtiene el valor de los detalles de saliente y entrante
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  getInOutputValue() {

    //obtener balance del servicio
    this.isBtnDisabled = true;
    this.callLogDetailService.getInOutputValue().subscribe((valData => {
      this.isBtnDisabled = false;
      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return false;
      }

      this.outputValue = valData["obj"].outputCostValue;
      this.inputValue = valData["obj"].inputCostValue;

    }),
      (err) => {
        this.outputValue = null;
        this.inputValue = null;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
  * Description: Método que oculta el modal general
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  hideModal() {
    this.isShowModal = false;
    this.isShowTermsModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/su-cuenta']);
    }
  }

  /**
 * Description: Método que abre el modal de terminos y condiciones
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  openTermsModal() {
    this.isShowTermsModal = true;
  }


  /**
  * Description: Método que verifica que check seleccionaron
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  validateCheckedAuthorization() {
    this.isAuthChecked = false;
    this.isTermsChecked = false;
    if ($('input#authCheckBox').is(':checked')) {
      this.isAuthChecked = true;
    }

    if ($('input#termsCheckBox').is(':checked')) {
      this.isTermsChecked = true;
    }
  }

  /**
* Description: Método que verifica que las fechas esten en el rango correcto
* Autor: Diego Diaz
* @param N/A
* @return N/A
*/
  isValidDateRange(initDate, endDate) {
    var isValid = false;

    var today = new Date();
    let currentDate = today.getFullYear()
      + "-"
      + ((today.getMonth() + 1 <= 9) ? '0'
        + (today.getMonth() + 1) : today.getMonth() + 1)
      + "-"
      + today.getDate();

    if ((initDate.value > endDate.value) && (endDate.value > currentDate)) {
      isValid = true;
    }

    return isValid;
  }

  /**
  * Description: Método que valida y envia la peticion de detalles de llamadas
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  sendCallLogRequest() {

    this.isBtnDisabled = true;
    let lines = this.callLogForm.get('inputLines');
    let initDate = this.callLogForm.get('inputInitDate');
    let endDate = this.callLogForm.get('inputEndDate');
    let balanceCost = this.callLogForm.get('inputBalance');

    // Validacion de campos
    if (lines.invalid || initDate.invalid || endDate.invalid) {
      this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_TITLE');
      this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_CONTENT');
      this.isShowModal = true;
      this.isBtnDisabled = false;
      return;
    }

    // Validacion de autorización
    if (!this.isTermsChecked || !this.isAuthChecked) {
      this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_AUTH_TITLE');
      this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_AUTH_CONTENT');
      this.isShowModal = true;
      this.isBtnDisabled = false;
      return;
    }

    //validación de maximo 360 dias
    if (this.difDaysValidation > constants.CALL_LOG_DETAIL_MAX_DAY_ALLOWED) {
      this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_TITLE');
      this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_MAX_DAYS_ALLOWED');
      this.isShowModal = true;
      this.isBtnDisabled = false;
      return;
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    /**
     * @ModifiedBy Julian Ciro
     * Se cambia la forma de formatear la fecha de inicio y final
     * Se elimina el metodo formatDate
     * Se agrega replace en la conversión de fechas, debido a que en IE(solo en este) se agregan símbolos al enviarlos en el json
     */
    let jsonData = {
      "identification": userData.documentId,
      "msisdn": this.callLogForm.get('inputLines').value,
      "startDateTime": this.callLogForm.get('inputInitDate').value.toLocaleDateString('en-GB', this.optionsFormatDate).replace(/[^ -~]/g,''),
      "endDateTime": this.callLogForm.get('inputEndDate').value.toLocaleDateString('en-GB', this.optionsFormatDate).replace(/[^ -~]/g,''),
      "customerAccountId": userData.customerAccountId,
      "type": (this.inOutSelected == 1) ? constants.INCOMING : constants.OUTCOMING,
      "daysContemplate": this.difDaysValidation,
      "authorizePay": constants.YES,
      "authorizeSend": constants.YES,
      "acceptTerms": constants.YES,
      "email": userData.email
    };

    let codificador = new CodificadorJWT();
    const jwt = codificador.generarJSON(jsonData, this.valueAes);
    const body = { args: jwt };

    //procesar envio request
    this.callLogDetailService.sendCallLogRequest(JSON.stringify(body)).subscribe((valData => {
      this.isBtnDisabled = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_LABEL_ERROR_REQUEST');
        this.isShowModal = true;
        return false;
      }

      //habilitar botones
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_TITLE_REQUEST_SENT');
      this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_CONTENT_1_REQUEST_SENT') + " "
        + initDate.value.toLocaleDateString('en-GB', this.optionsFormatDate).replace(/[^ -~]/g,'') + " "
        + this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_CONTENT_2_REQUEST_SENT') + " "
        + endDate.value.toLocaleDateString('en-GB', this.optionsFormatDate).replace(/[^ -~]/g,'') + " "
        + this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_CONTENT_3_REQUEST_SENT') + " "
        + userData.email + " "
        + this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_CONTENT_4_REQUEST_SENT');

      this.isModalReload = true;
      this.isShowModal = true;

    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        this.isBtnDisabled = false;
      });
  }

  /**
  * Description: Método que asigna la linea seleccionada desde el select
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  selectedLine($event) {
    /**
     * @ModifiedBy Julian Ciro
     * Se simplica el metodo a lo que se hacia antes a una sola linea
     */
    this.requestedLine = $event.target.value;
  }

  /**
  * Description: Método que asigna el valor de los dias entre las fechas seleccionadas
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  calcDayRange(dateValue: Date, dateRange: string) {
    //@ModifiedBy Julian Ciro Barrera
    //Se agrega esta validación para el evento, ya que se ejecuta primero este metodo a 
    //que el formControl tome el valor seleccionado en el datepicker
    if(dateRange === 'init' && dateValue){
      this.callLogForm.get('inputInitDate').setValue(dateValue);
    } else if(dateRange === 'end' && dateValue){
      this.callLogForm.get('inputEndDate').setValue(dateValue);
      this.maxDateToInitDate = dateValue;
    }
    let initDate = this.callLogForm.get('inputInitDate').value;
    let endDate = this.callLogForm.get('inputEndDate').value;

    if (this.callLogForm.get('inputInitDate').invalid || this.callLogForm.get('inputEndDate').invalid) {
      return false;
    } else {
      let oneDay = 24 * 60 * 60 * 1000;
      let firstDate = new Date(initDate);
      let secondDate = new Date(endDate);
      this.difDaysValidation = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay))) + 1; //Mas el ultimo dia completo
      /**
       * @ModyfiedBy Julian Ciro
       * Se quitan validaciones de fecha inicial mayor a final y/o viceversa y se añade la de días superior a 360
       */
      if(this.difDaysValidation > 360){
        this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_TITLE');
        this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_MAX_DAYS_ALLOWED');
        this.isShowModal = true;
      }
      this.callLogForm.patchValue({ inputDays: this.difDaysValidation });
    }
  }

  /**
  * Description: Método que asigna el valor de la opcion seleccionada del tipo entrantes o salientes
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  setSelectedInOutRadio(id) {
    this.inOutSelected = id;
  }

  /**
  * Description: Método que asigna la clase activa al checkbox de llamadas entrantes o salientes
  * Autor: Steven Sterling
  * @param id identificador del check
  * @return N/A
  */
  changeCheckClass(id) {
    if (id == 1) {
      $("#inoutBtn1").addClass("active");
      $("#inoutBtn2").removeClass("active");
      $("#inoutRadios1").prop("checked", "checked");
    } else if (id == 2) {
      $("#inoutBtn2").addClass("active");
      $("#inoutBtn1").removeClass("active");
      $("#inoutRadios2").prop("checked", "checked");
    }
    this.setSelectedInOutRadio(id);
  }

  getSemillaAesParam(){
		this.privacyService.getGroupParameters("WS_SEMILLA").subscribe(((dataResponse:any) => {
      this.valueAes = dataResponse.obj[0].value
		}))
	}
}
